import { Platform } from "react-native";
import { Diamond } from "@src/types/DiamondDetail";
import { ProductCategory } from "@utils/constants";

export type ExternalCartPayload = {
  type: "VDB_ADD_TO_CART";
  data: ExternalCartItemData;
};

export type ExternalCartItemData = {
  id: number | string;
  stock_number?: string;
  product_type: string;
  shape?: string;
  carat_weight?: string;
  color?: string;
  clarity?: string;
  cut?: string;
  certifier?: string;
  cert_num?: string;
  price?: string;
  currency?: string;
  quantity: number;
  jewelry_style?: string;
  brand?: string;
  jewelry_description?: string;
  gem_type?: string;
  configuration?: Record<string, any>;
  personalization?: Record<string, any>;
  title?: string;
  image_url?: string;
};

export const buildExternalCartItemData = (
  itemDetail: Diamond,
  productType: string,
  quantity: number = 1,
  configuration?: Record<string, any>,
  personalization?: Record<string, any>
): ExternalCartItemData => {
  return {
    id: itemDetail.id,
    stock_number: itemDetail.stock_num,
    product_type: productType,
    shape: itemDetail.shape_long || itemDetail.shape,
    carat_weight: itemDetail.size,
    color: itemDetail.color,
    clarity: itemDetail.clarity,
    cut: itemDetail.cut_long || itemDetail.cut,
    certifier: itemDetail.lab_long || itemDetail.lab,
    cert_num: itemDetail.cert_num,
    price: itemDetail.total_sales_price,
    currency: itemDetail.currency_code || "USD",
    quantity,
    jewelry_style: itemDetail.jewelry_style,
    brand: itemDetail.brand,
    jewelry_description: itemDetail.jewelry_description,
    gem_type: itemDetail.gem_type,
    configuration,
    personalization,
    title: itemDetail.short_title || itemDetail.long_title,
    image_url: itemDetail.image_url,
  };
};

export const getMaxExternalCartQuantity = (
  productType: string,
  requestedQuantity: number = 1
): number => {
  switch (productType) {
    case ProductCategory.DIAMOND:
    case ProductCategory.LAB_GROWN_DIAMOND:
    case ProductCategory.GEMSTONE:
      return 1;
    case ProductCategory.JEWELRY:
      return requestedQuantity;
    default:
      return 1;
  }
};

export const sendToParentCart = (
  itemDetail: Diamond,
  productType: string,
  quantity: number = 1,
  configuration?: Record<string, any>,
  personalization?: Record<string, any>
): boolean => {
  if (Platform.OS !== "web") {
    return false;
  }

  try {
    const clampedQuantity = getMaxExternalCartQuantity(productType, quantity);

    const payload: ExternalCartPayload = {
      type: "VDB_ADD_TO_CART",
      data: buildExternalCartItemData(
        itemDetail,
        productType,
        clampedQuantity,
        configuration,
        personalization
      ),
    };

    window.parent.postMessage(payload, "*");
    return true;
  } catch (error) {
    console.error("Failed to send item to parent cart:", error);
    return false;
  }
};
